var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-skeleton-loader",
    {
      staticClass: "dashboard-component",
      attrs: {
        transition: "scale-transition",
        type: "image",
        height: "260",
        "min-height": "335",
        loading: _vm.isLoading
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "pull-up" },
        [
          _c(
            "v-card-title",
            { staticClass: "overline pb-1 d-flex justify-start" },
            [_c("h3", [_vm._v("Tickets creados a través del Portal")])]
          ),
          _c(
            "v-card-text",
            {
              staticClass: "d-flex justify-center",
              attrs: { collapse: "", show: "" }
            },
            [
              _c(
                "v-container",
                { staticClass: "pa-0", attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        "align-content": "center",
                        justify: "center",
                        dense: "",
                        "no-gutters": ""
                      }
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-0 ma-0 tickets-review-chart",
                          attrs: { cols: "12" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mx-8" },
                            [
                              _c("apexchart", {
                                staticClass: "dashboard-chart",
                                attrs: {
                                  type: _vm.chartType,
                                  options: _vm.ticketsReviewOptions,
                                  series: [
                                    _vm.portalMonthTickets[0]
                                      ? _vm.portalMonthTickets[0].total
                                      : 0,
                                    _vm.portalMonthTickets[2]
                                      ? _vm.portalMonthTickets[2].total
                                      : 0,
                                    _vm.portalMonthTickets[1]
                                      ? _vm.portalMonthTickets[1].total
                                      : 0
                                  ]
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-row",
                    {
                      attrs: {
                        align: "center",
                        "align-content": "center",
                        justify: "center",
                        dense: "",
                        "no-gutters": ""
                      }
                    },
                    _vm._l(_vm.portalMonthTickets, function(element) {
                      return _c(
                        "v-col",
                        {
                          key: element.id,
                          staticClass: "pa-0 ma-0 ticket-type",
                          class:
                            element.id === 1
                              ? "req"
                              : element.id === 2
                              ? "inc"
                              : "acc",
                          attrs: { cols: "6" }
                        },
                        [
                          _c(
                            "h3",
                            { staticClass: "d-flex justify-center overline" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getTicketName(element.id)) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center value" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(element.total ? element.total : 0) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex justify-center extra" },
                            [
                              _vm._v(
                                " (" + _vm._s(element.subtractionText) + ") "
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }